import { atom } from "jotai";

export const vesselAtom = atom({});
